import removeCircularReferences from './removeCircularReferences';
export default removeCircularReferences;